import { Button, Notification } from '@sorrem-client/ui/components';
import { useGameplay } from '@sorrem-client/ui/features/PlayPage/gameplay-context';
import { useGameSelector } from '@sorrem-client/ui/hooks';
import { useLeaveRun } from '@sorrem-client/ui/features/PlayPage/use-leave-run';
import styles from './GameOverlayConnectionNotices.module.scss';

/** Reloading rejoins the run; returning leaves it for Character Home. */
function RejoinOrLeaveActions(): JSX.Element {
    const leaveRun = useLeaveRun();
    return (
        <div className={styles.noticeActions}>
            <Button onClick={() => window.location.reload()}>Reload</Button>
            <Button variant="secondary" onClick={() => { void leaveRun('crucibles'); }}>Return to character</Button>
        </div>
    );
}

/**
 * Why the run can't go on, while it hasn't ended: a fatal error, or the
 * connection to it dropping. Shown over the loading screen too: a drop
 * while loading must never look like a hang (#72).
 */
export function GameOverlayConnectionNotices(): JSX.Element | null {
    const { bridge } = useGameplay();
    const hasRunEnded = useGameSelector(bridge, (state) => state.runResult !== null);
    const fatalError = useGameSelector(bridge, (state) => state.fatalError);
    const connectionLost = useGameSelector(bridge, (state) => state.isConnectionLost);

    if (hasRunEnded) {
        return null;
    }
    return (
        <>
            {fatalError !== null && (
                <Notification title="Something Went Wrong" message={`${fatalError} Reload to rejoin the run.`}>
                    <RejoinOrLeaveActions />
                </Notification>
            )}
            {connectionLost && (
                <Notification
                    title="Connection Lost"
                    message="Your connection to the run dropped. Reconnecting... Your character is held for a minute; reloading the page rejoins too."
                >
                    <RejoinOrLeaveActions />
                </Notification>
            )}
        </>
    );
}
